function fn_comp_quotes() {
    var $fn = $(".comp_quotes"),
        $slider = $fn.find("[data-slider]"),
        $slider_nav = $fn.find("[data-slider-nav]");

    if ($fn.length) {
        if ($slider.children().length > 1) {
            $slider.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 6000,
                fade: true,
                cssEase: 'linear',
                adaptiveHeight: true
            });

            $slider_nav.find(".elm_prev").on("click", function(e) {
                e.preventDefault();
                $slider.slick("slickPrev");
            });

            $slider_nav.find(".elm_next").on("click", function(e) {
                e.preventDefault();
                $slider.slick("slickNext");
            });
        }
    }
}